export function displayOddsType(id, output, condition) {
  switch (id) {
    case ODDSTYPES.threeway:
      if (output === 'o1') return '1x2 (Home)'
      else if (output === 'o2') return '1x2 (Draw)'
      return '1x2 (Away)'
    case ODDSTYPES.totals:
      if (output === 'o1') return 'Over ' + condition.toFixed(2)
      return 'Under ' + condition.toFixed(2)
    case ODDSTYPES.moneyline:
      if (output === 'o1') return 'Home to win'
      return 'Away to win'
    case ODDSTYPES.dnb:
      if (output === 'o1') return 'Draw no bet (Home)'
      return 'Draw no bet (Away)'
    case ODDSTYPES.ahc:
      if (output === 'o1') {
        if (condition < 0) return 'Asian hcp ' + condition.toFixed(2) + ' (Home)'
        return 'Asian hcp +' + condition.toFixed(2) + ' (Home)'
      }
      if (condition < 0) return 'Asian hcp +' + condition.toFixed(2) * -1 + ' (Away)'
      return 'Asian hcp ' + condition.toFixed(2) * -1 + ' (Away)'
    case ODDSTYPES.points:
      if (output === 'o1') {
        if (condition < 0) return 'Handicap ' + condition.toFixed(2) + ' (Home)'
        return 'Handicap +' + condition.toFixed(2) + ' (Home)'
      }
      if (condition < 0) return 'Handicap +' + condition.toFixed(2) * -1 + ' (Away)'
      return 'Handicap ' + condition.toFixed(2) * -1 + ' (Away)'
    case ODDSTYPES.ehc:
      let resultString = ''
      if (condition >= 0) {
        resultString = '(' + condition + '-0)'
      } else {
        resultString = '(0' + condition + ')'
      }
      if (output === 'o1')
        return 'Euro hcp ' + resultString + ' (Home)'
      else return 'Euro hcp ' + resultString + ' (Away)'
    default:
      return 'N/A'
  }
}

export const ODDSTYPES = {
  threeway: 0,
  moneyline: 1,
  points: 3,
  totals: 4,
  ahc: 5,
  totalsht: 65540,
  threewayht: 65536,
  dnb: 6291457,
  totalcorners: 9437188,
  totalcornersht: 9502724,
  ehc: 8388608
}

export const currencyToIcon = {
  NOK: 'NOK',
  USD: 'fa fa-usd',
  DKK: 'DKK',
  GBP: 'fa fa-gbp',
  EUR: 'fa fa-eur',
  CAD: 'CAD',
  SEK: 'SEK'
}

export const getDisplayCurrency = {
  NOK: 'NOK',
  USD: '$',
  DKK: 'DKK',
  GBP: '£',
  EUR: '€',
  CAD: 'CAD',
  SEK: 'SEK'
}

export function currencyToText(amount, currency) {
  if (currency === 'USD' || currency === 'GBP' || currency === 'EUR') {
    return getDisplayCurrency[currency] + amount
  } else {
    return amount + ' ' + getDisplayCurrency[currency]
  }
}

export function convertCurrency(from, to, amount, rates) {
  if (from === to) return amount
  return rates[from][to] * amount;
}

export const getStatus = {
  1: {
    text: 'Open',
    className: 'info'
  },
  2: {
    text: 'Won',
    className: 'success'
  },
  3: {
    text:'Lost',
    className: 'danger'
  },
  4: {
    text: 'Void',
    className:'warning'
  },
  5: {
    text: '1/2 Won',
    className: 'success'
  },
  6: {
    text: '1/2 Lost',
    className: 'danger'
  }

}

export const SPORTS = {
  1: {
    name: 'Soccer',
    icon: 'ionicons ion-ios-football'
  },
  3: {
    name: 'Basket',
    icon: 'ionicons ion-ios-basketball'
  },
  4: {
    name: 'Rugby',
    icon: 'ionicons ion-ios-americanfootball'
  },
  5: {
    name: 'Tennis',
    icon: 'ionicons ion-ios-tennisball'
  },
  6: {
    name: 'American football',
    icon: 'ionicons ion-ios-americanfootball'
  },
  7: {
    name: 'Baseball',
    icon: 'ionicons ion-ios-baseball'
  },
  8: {
    name: 'Handball',
    icon: 'ionicons ion-android-hand'
  }
}

export const PLAN_NAMES = {
  hobby: 'Hobby',
  prom: 'Pro Monthly',
  proq: 'Pro Quarterly'
}



/** WEBPACK FOOTER **
 ** ./src/utils/converters.js
 **/